var o = 9007199254740991, d = /^(?:0|[1-9]\d*)$/;
function f(r, s) {
  var t = typeof r;
  return s = s ?? o, !!s && (t == "number" || t != "symbol" && d.test(r)) && r > -1 && r % 1 == 0 && r < s;
}
export {
  f as default
};
